import dayjs from "dayjs";

const secondsInHour = 3600;
const secondsInTenMin = 600;

export const getFormattedDuration = (
  duration: number,
  formatObj = {
    lg: "H:mm:ss",
    md: "mm:ss",
    sm: "m:ss",
  },
) => {
  return duration >= secondsInHour
    ? dayjs.utc(duration * 1000).format(formatObj.lg)
    : duration >= secondsInTenMin
      ? dayjs.utc(duration * 1000).format(formatObj.md)
      : dayjs.utc(duration * 1000).format(formatObj.sm);
};
const ariaFormatObj = {
  lg: "H [hours] mm [minutes] ss [seconds]",
  md: "mm [minutes] ss [seconds]",
  sm: "m [minutes] ss [seconds]",
};

/**
 * returns an object that has a visually appealing
 * date as well as one for screen readers
 */
export const durationFormatted = (duration: number) => ({
  value: getFormattedDuration(duration),
  ariaLabel: getFormattedDuration(duration, ariaFormatObj),
});
